var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"c-shared-stars"},_vm._l((this.quantity),function(index){return _c('shared-stars-item',{key:index})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }